/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createOrUpdateMerchantUnitOvertimeRuleset} from '../api'

export const useMutationCreateOrUpdateMerchantUnitOvertimeRuleset = createReactQueryMutationHook('createOrUpdateMerchantUnitOvertimeRuleset', createOrUpdateMerchantUnitOvertimeRuleset)
